/* Dagrox — cart-drawer.js
   Shopify AJAX Cart API (live).
   Endpoints: /cart/add.js · /cart.js · /cart/change.js · /cart/update.js
   Money is in cents (Shopify standard); rendering uses store currency formatting.
*/
(function () {
  'use strict';

  var EUR = function (cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return '€ ' + v;
  };

  var drawer, scrim, itemsEl, subtotalEl, badgeEls;
  var state = { item_count: 0, items: [], total_price: 0 };
  var inflight = false;

  function api(path, opts) {
    var defaults = { credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } };
    var merged = Object.assign({}, defaults, opts || {});
    if (merged.body && typeof merged.body !== 'string') merged.body = JSON.stringify(merged.body);
    return fetch(path, merged).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    });
  }

  // fix-carrello-20261006: il banner dei cookie di Shopify (#shopify-pc__banner, z-index 2000000) resta in fondo allo
  // schermo finché il cliente non risponde e copriva "Vai al checkout" su mobile. Il piede del carrello sale sopra il banner
  // (variabile --consent-h) e torna giù appena il banner sparisce. Il banner resta visibile e funzionante.
  var consentWatch = null;
  function consentOffset() {
    if (!drawer) return;
    var h = 0;
    var b = document.getElementById('shopify-pc__banner');
    if (b && drawer.classList.contains('open')) {
      var s = window.getComputedStyle(b);
      if (s.display !== 'none' && s.visibility !== 'hidden' && parseFloat(s.opacity || '1') > 0) {
        var r = b.getBoundingClientRect();
        if (r.height > 0 && r.top < window.innerHeight) h = Math.round(window.innerHeight - r.top);
      }
    }
    // Scrive solo se il valore cambia: altrimenti l'osservatore vedrebbe la propria modifica e ripartirebbe a ogni frame.
    if (drawer.style.getPropertyValue('--consent-h') !== h + 'px') drawer.style.setProperty('--consent-h', h + 'px');
  }
  function watchConsent() {
    consentOffset();
    if (consentWatch || !window.MutationObserver) return;
    consentWatch = new MutationObserver(function () { requestAnimationFrame(consentOffset); });
    consentWatch.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
  }
  function unwatchConsent() {
    if (consentWatch) { consentWatch.disconnect(); consentWatch = null; }
    if (drawer) drawer.style.setProperty('--consent-h', '0px');
  }
  window.addEventListener('resize', function () { if (drawer && drawer.classList.contains('open')) consentOffset(); }, { passive: true });

  function open() {
    if (!drawer) return;
    drawer.classList.add('open');
    scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    watchConsent();
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('open');
    scrim.classList.remove('open');
    document.body.style.overflow = '';
    unwatchConsent();
  }

  function syncBadge() {
    var n = state.item_count || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(n);
      el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
  }

  function render() {
    if (!itemsEl) return;
    requestAnimationFrame(function () { _render(); });
  }

  // velocita-20261011: la miniatura del carrello è larga 84 px, ma cart.js restituisce la foto originale (anche 1-2 MB).
  // Si chiede al CDN di Shopify la versione da 300 px, che basta anche agli schermi 3x: il carrello si riempie subito.
  function sized(url, width) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }
  function _render() {
    if (!itemsEl) return;
    if (!state.items || state.items.length === 0) {
      itemsEl.innerHTML = ''
        + '<div class="drawer-empty">'
        + '  <div class="e-num">N° 00</div>'
        + '  <h4>Il carrello è ancora vuoto</h4>'
        + '  <p>Aggiungi un prodotto per continuare.</p>'
        + '</div>';
      subtotalEl.textContent = EUR(0);
      return;
    }
    var html = state.items.map(function (i, idx) {
      var lineKey = i.key;
      var line = idx + 1;
      var img = sized(i.featured_image && i.featured_image.url ? i.featured_image.url : (i.image || ''), 300);
      // ECOAA-99 (D5): due varianti dello stesso prodotto rendevano due righe
      // testualmente identiche (solo la miniatura le distingueva). Il nome della
      // variante va sempre stampato, tranne quando Shopify usa il segnaposto
      // 'Default Title' dei prodotti a variante unica.
      var vt = i.variant_title || '';
      if (vt === 'Default Title') vt = '';
      return ''
        + '<article class="drawer-item">'
        + '  <div class="thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>'
        + '  <div class="meta">'
        + '    <span class="n">' + escapeHtml(i.product_type || '') + '</span>'
        + '    <span class="name">' + escapeHtml(i.product_title) + '</span>'
        + (vt ? '    <span class="variant" style="font-size:12px;letter-spacing:.02em;color:var(--avorio-mute,#9a9a9a)">' + escapeHtml(vt) + '</span>' : '')
        + '    <div class="qty" role="group" aria-label="Quantità">'
        + '      <button type="button" aria-label="Diminuisci" data-qty-dec="' + escapeAttr(lineKey) + '" data-line="' + line + '">−</button>'
        + '      <span class="val">' + i.quantity + '</span>'
        + '      <button type="button" aria-label="Aumenta" data-qty-inc="' + escapeAttr(lineKey) + '" data-line="' + line + '">+</button>'
        + '    </div>'
        + '    <button type="button" class="remove" data-remove="' + escapeAttr(lineKey) + '" data-line="' + line + '">Rimuovi</button>'
        + '  </div>'
        + '  <div class="price-col">' + EUR(i.final_line_price) + '</div>'
        + '</article>';
    }).join('');
    itemsEl.innerHTML = html + '<div class="drawer-bump" data-cart-bump hidden></div>';
    subtotalEl.textContent = EUR(state.total_price);
    loadBump();
  }

  // order-bump-20261017: sotto gli articoli, un prodotto da abbinare preso da custom.related dei prodotti nel carrello.
  // Lo sceglie sections/cart-bump.liquid (Section Rendering API); si richiede solo quando cambiano i prodotti nel carrello,
  // non le quantità. Se la richiesta fallisce o non c'è niente da suggerire, il riquadro resta nascosto.
  var bumpCache = { key: null, html: '' };
  function bumpKey() {
    return (state.items || []).map(function (i) { return i.product_id; }).sort().join(',');
  }
  function placeBump(html) {
    var box = itemsEl ? itemsEl.querySelector('[data-cart-bump]') : null;
    if (!box) return;
    box.innerHTML = html;
    box.hidden = !html;
    // stesso formato del resto del carrello ("29,90 €")
    box.querySelectorAll('[data-bump-cents]').forEach(function (el) {
      var c = parseInt(el.getAttribute('data-bump-cents'), 10);
      if (!isNaN(c)) el.textContent = EUR(c);
    });
  }
  function loadBump() {
    var key = bumpKey();
    if (!key) return;
    if (bumpCache.key === key) { placeBump(bumpCache.html); return; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?section_id=cart-bump', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (txt) {
        var tmp = document.createElement('div');
        tmp.innerHTML = txt;
        var el = tmp.querySelector('[data-bump]');
        bumpCache = { key: key, html: el ? el.outerHTML : '' };
        if (bumpKey() === key) placeBump(bumpCache.html);
      })
      .catch(function () { /* nessun suggerimento: il carrello funziona lo stesso */ });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) {
    return String(s == null ? '' : s).replace(/"/g, '&quot;');
  }

  function fetchCart() {
    return api('/cart.js').then(function (data) {
      state = data;
      render();
      syncBadge();
      return data;
    });
  }

  function addToCart(variantId, qty) {
    if (inflight) return Promise.resolve();
    inflight = true;
    return api('/cart/add.js', { method: 'POST', body: { id: variantId, quantity: qty || 1 } })
      .then(function () { return fetchCart(); })
      .then(function () { open(); })
      .catch(function (err) {
        console.warn('Add to cart failed:', err);
        alert(err && err.description ? err.description : 'Errore durante l\'aggiunta al carrello.');
      })
      .finally(function () { inflight = false; });
  }

  function addMany(items) {
    if (inflight) return Promise.resolve();
    inflight = true;
    return api('/cart/add.js', { method: 'POST', body: { items: items } })
      .then(function () { return fetchCart(); })
      .then(function () { open(); })
      .catch(function (err) {
        console.warn('Add many failed:', err);
        alert(err && err.description ? err.description : 'Errore durante l\'aggiunta al carrello.');
      })
      .finally(function () { inflight = false; });
  }

  function changeLine(line, qty) {
    if (inflight) return Promise.resolve();
    inflight = true;
    return api('/cart/change.js', { method: 'POST', body: { line: line, quantity: qty } })
      .then(function (data) { state = data; render(); syncBadge(); })
      .finally(function () { inflight = false; });
  }

  function wire() {
    drawer = document.getElementById('cart-drawer');
    scrim = document.getElementById('cart-scrim');
    if (!drawer) return;

    itemsEl = drawer.querySelector('[data-cart-items]');
    subtotalEl = drawer.querySelector('[data-cart-subtotal]');

    scrim.addEventListener('click', close, { passive: true });
    // FIX 2026-07: c'erano DUE tasti chiudi (drawer-back + drawer-close) ma
    // querySelector legava solo il primo -> il secondo non chiudeva. Ora tutti.
    drawer.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); }, { passive: true });

    document.querySelectorAll('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });

    // Single add-to-cart from card / PDP
    document.addEventListener('click', function (e) {
      var addOne = e.target.closest('[data-add-variant-id]');
      if (addOne) {
        e.preventDefault();
        var vid = addOne.getAttribute('data-add-variant-id');
        var qtyAttr = addOne.getAttribute('data-qty');
        var qty = qtyAttr ? parseInt(qtyAttr, 10) : 1;
        addToCart(vid, qty);
        return;
      }

      var addPDP = e.target.closest('[data-add-from-pdp]');
      if (addPDP) {
        e.preventDefault();
        var form = addPDP.closest('form[data-product-form]');
        var vid2 = form ? form.querySelector('[name="id"]').value : addPDP.getAttribute('data-add-from-pdp');
        var qtyEl = form ? form.querySelector('[data-pdp-qty-val]') : null;
        var qty2 = qtyEl ? parseInt(qtyEl.value || '1', 10) : 1;
        addToCart(vid2, qty2);
        return;
      }

      var addMulti = e.target.closest('[data-add-multi]');
      if (addMulti) {
        e.preventDefault();
        var raw = addMulti.getAttribute('data-add-multi');
        try {
          var items = JSON.parse(raw);
          addMany(items);
        } catch (_) {}
        return;
      }
    });

    // Drawer interactions (qty / remove)
    // fix-audit-20260729: guard aggiunto — se [data-cart-items] manca dal markup del drawer,
    // itemsEl è null e la addEventListener sotto lanciava un'eccezione non catturata,
    // interrompendo wire() a metà (swipe-to-close e fetchCart() iniziale non si agganciavano
    // più). Non tocca il flag inflight né altra logica.
    if (itemsEl) {
      itemsEl.addEventListener('click', function (e) {
        var inc = e.target.closest('[data-qty-inc]');
        var dec = e.target.closest('[data-qty-dec]');
        var rm  = e.target.closest('[data-remove]');
        if (inc) {
          var line = parseInt(inc.getAttribute('data-line'), 10);
          var current = state.items[line - 1].quantity;
          changeLine(line, Math.min(10, current + 1));
        } else if (dec) {
          var line2 = parseInt(dec.getAttribute('data-line'), 10);
          var current2 = state.items[line2 - 1].quantity;
          changeLine(line2, Math.max(0, current2 - 1));
        } else if (rm) {
          var line3 = parseInt(rm.getAttribute('data-line'), 10);
          changeLine(line3, 0);
        }
      });
    }

    // Swipe right to close drawer (mobile)
    var touchStartX = 0;
    var touchStartY = 0;
    drawer.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    drawer.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
      if (dx > 60 && dy < 100) close();
    }, { passive: true });

    // Initial sync
    fetchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else { wire(); }
})();
